import { ProductCategoryTypeEnum } from "./product-category-type-enum";

export const ProductCategoryTypeLabels = {
  [ProductCategoryTypeEnum.LENS]: "Lensa",
  [ProductCategoryTypeEnum.NON_LENS]: "Non-Lensa",
};
